import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions as configuredFunctions } from '../config/firebase';

/**
 * Rewrite imported rider text into VRC writer HTML via Cloud Functions + OpenAI.
 * @param {string} plainText
 * @param {{ tourName?: string }} options
 * @returns {Promise<string>} HTML fragment
 */
export async function formatRiderDocumentWithAI(plainText, { tourName = '' } = {}) {
  const text = String(plainText || '').trim();
  if (!text) throw new Error('No readable text was found in that document.');

  const formatRiderDocumentWithAI = httpsCallable(
    configuredFunctions || getFunctions(),
    'formatRiderDocumentWithAI'
  );

  const response = await formatRiderDocumentWithAI({
    plainText: text.slice(0, 120000),
    tourName: String(tourName || '').trim(),
  });

  const html = String(response?.data?.html || '').trim();
  if (!html) throw new Error('AI formatting returned empty content. Try importing as-is instead.');
  return html;
}

export default formatRiderDocumentWithAI;
